import logUtil from 'utils/log'

/**
 * @param props
 * @param props.shouldShowFastTrackExpiry
 * @param props.isInGiftingMode
 * @param props.isGiftOrSelfGiftingUrl
 * @param props.shouldShowFastTrackModalOrBannerExpiring
 * @param props.isHomeUrl
 * @param props.isMixedCollectionUrl
 * @param props.hasOngoingDeals
 * @param props.shouldShowUnlockedExtraFreeSamplesBanner
 * @returns {boolean}
 */
const shouldShowFastTrackExpiryBannerLoyaltySelectUtil = ({
  shouldShowFastTrackExpiry,
  isInGiftingMode,
  isGiftOrSelfGiftingUrl,
  shouldShowFastTrackModalOrBannerExpiring,
  hasOngoingDeals,
  isHomeUrl,
  isMixedCollectionUrl,
  shouldShowUnlockedExtraFreeSamplesBanner
}) => {
  if (shouldShowUnlockedExtraFreeSamplesBanner) {
    return false
  }

  if (
    hasOngoingDeals &&
    isHomeUrl
  ) {
    return false
  }

  const res = !!(
    !isMixedCollectionUrl &&
    !isGiftOrSelfGiftingUrl &&
    !isInGiftingMode &&
    shouldShowFastTrackExpiry &&
    shouldShowFastTrackModalOrBannerExpiring
  )

  const debugProps = {
    res
  }
  logUtil('shouldShowFastTrackExpiryBannerLoyaltySelectUtil').debug('debugProps=', debugProps)
  return res
}

export default shouldShowFastTrackExpiryBannerLoyaltySelectUtil
